import styled from 'styled-components';

import { min } from '../../../../utils/breakpoints';

const Container = styled.div<{ $compact?: boolean }>`
  margin-top: ${(props) => (props.$compact ? 0 : '50px')};

  ${min.sm} {
    margin-top: ${(props) => (props.$compact ? 0 : '80px')};
  }
`;

export default Container;
